import {combineReducers} from "redux";
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {reportsAPI} from "../../../api/reports";
import { createActions } from "../../factory/actionFactory";
import {START} from "../../../constants/action-postfix";
import { loaderReducer } from "./loader/loaderReducer";
import { formReducer } from "./form/formReducer";
import { dataReducer } from "./data/dataReducer";
import { getModifyData, getQueryParams } from "../../../utils/hiringPlan";



export const HIRING_PLAN_REQUEST = "HIRING_PLAN_REQUEST";
export const SET_FORM_DATA = "SET_HIRING_PLAN_FORM_DATA";

export const hiringPlanReducer = combineReducers({
    form: formReducer,
    data: dataReducer,
    loader: loaderReducer,
});

//actions
export const hiringPlanActions = createActions('hiringPlan', HIRING_PLAN_REQUEST);
export const setFormData = payload => ({ type: SET_FORM_DATA, payload});

// SAGAS
export function* hiringPlanWatcher() {
    yield takeLatest(`${HIRING_PLAN_REQUEST}${START}`, hiringPlanWorker)
}

function* hiringPlanWorker() {
    try {
        const auth = yield select(state => state.auth.data)
        const form = yield select(state => state.reports.hiringPlan.form)
        const queryParams = getQueryParams(form)
        const params = {...auth, ...queryParams}
        const response = yield call(reportsAPI.hiringPlan, params);
        const {Candidates, Students} = response.data.Answer
        const data = getModifyData(Candidates, Students)
        yield put(hiringPlanActions.hiringPlanRequestSuccess(data));
    } catch(error) {
        yield put(hiringPlanActions.hiringPlanRequestError(error));
    }
}



